import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

// Line Graph
const LineGraph = ({ data, title, format, yAxisType }) => {
  let yxisFormatter = function (val) {
    return format + val;
  };


  if (yAxisType === "time") {
    yxisFormatter = function (totalSeconds) {
      const sign = totalSeconds < 0 ? "-" : "";
      const absSeconds = Math.abs(totalSeconds);

      const hours = Math.floor(absSeconds / 3600);
      const minutes = Math.floor((absSeconds % 3600) / 60);
      const seconds = absSeconds % 60;

      return sign + [
        hours.toString().padStart(2, "0"),
        minutes.toString().padStart(2, "0"),
        seconds.toString().padStart(2, "0")
      ].join(":");
    };
  }


  const [chartData, setChartData] = useState({
    series: [
      {
        name: title,
        data: [],
      },
    ],
    options: {
      chart: {
        height: 250,
        type: "line",
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        categories: [],
        position: "top",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true,
          // formatter: function (val) {
          //   return format + val;
          // },
          formatter: yxisFormatter
        },
      },
      title: {
        text: title,
        align: "center",
        style: {
          color: "#444",
        },
      },
    },
  });

  // set the values for line graph based on props
  useEffect(() => {
    if (data?.recordcounts && data?.dates) {
      setChartData((prevGraphData) => ({
        ...prevGraphData,
        series: [
          {
            ...prevGraphData.series[0],
            data: data?.recordcounts,
            name: title
          },
        ],
        options: {
          ...prevGraphData.options,
          title: {
            ...prevGraphData.options.title,
            text: title,
          },
          xaxis: {
            ...prevGraphData.options.xaxis,
            categories:
              data?.dates?.length > 0
                ? data?.dates?.map((month) => month.slice(0, 3))
                : data?.courseNames,
          },
        },
      }));
    }
  }, [data, title, format]);

  return (
    <ReactApexChart
      options={chartData.options}
      series={chartData.series}
      type="line"
      height={250}
    />
  );
};

export default LineGraph;
